import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { queryKeys } from '@/queries/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/**
 * POST `/admin/login` — hydrates Zustand auth and refreshes the session query.
 */
export function useLoginMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    () => '/admin/login',
    'post',
    {},
    {
      onSuccess: (data) => {
        useAuthStore.getState().setSession(data);
        queryClient.invalidateQueries({ queryKey: queryKeys.session() });
        NotificationManager.success('Login success', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Login unsuccessful', '', 3000);
      },
    },
  );
}
